import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { fetchApiWithError } from '@upright/ui/api/common/fetchers/fetch-with-error';
import { deleteFromApi, postToApi } from '@upright/ui/api/common/fetchers/request-api';
import {
  CreateCompanyGroupRequest,
  CreateCompanyGroupResponse,
  EditGroupfolioRequest,
  EditGroupfolioResponse,
  GetGroupfolioResponse,
} from '../../../../../common/model/input/company-groups/api-types';
import { NamedModelEntityReference } from '../../../../../common/model/input/types';
import { ModelEntityWithScores } from '../../../../../common/model/output/scores/model-entity-data/types';
import { SuccessOrError } from '../../../../../common/types-api';

export async function getGroupfolio(id: string) {
  return await fetchOrThrow<GetGroupfolioResponse>(`/group/${id}`, 'GET');
}

export async function deleteCompanyGroup(id: string) {
  return await deleteFromApi<SuccessOrError>(`/group/${id}`);
}

export async function duplicateCompanyGroup(id: string) {
  return await postToApi<ModelEntityWithScores>(`/group/${id}/duplicate`);
}

export async function editGroupfolio(id: string, body: EditGroupfolioRequest) {
  return await fetchOrThrow<EditGroupfolioResponse>(`/group/${id}`, 'PATCH', body);
}

export async function createCompanyGroup(body: CreateCompanyGroupRequest) {
  return await fetchApiWithError<CreateCompanyGroupResponse>(`/group`, 'POST', body);
}

export async function fetchPortfoliosForGroup(groupId: string) {
  return await fetchOrThrow<NamedModelEntityReference[]>(`/group/${groupId}/portfolios`);
}

export async function triggerCompanyGroupPopulation(id: string) {
  return await fetchApiWithError<SuccessOrError>(`/group/${id}/populate`, 'POST');
}
